import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import {withStyles} from '@mui/styles';

const StyledTooltip = withStyles((theme) => ({
  arrow: {
    color: theme.palette.primary.main,
  },
  tooltip: {
    borderRadius: 10,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.gray.light,
    fontSize: 14,
  },
}))(Tooltip);

interface iProps {
  children: any;
  title: any;
  placement?: string;
  long?: boolean;
}

export default function BidmiiTooltip(props: iProps) {
  return (
    <StyledTooltip
      arrow
      title={props.title}
      enterDelay={!props.long ? 250 : 0}
      leaveDelay={250}
      enterTouchDelay={0}
      leaveTouchDelay={750}
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      placement={props.placement || 'bottom'}>
      {props.children}
    </StyledTooltip>
  );
}
